import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

const BackButton = ({ onClick, href, noPadding }) => (
  <div style={{ margin: noPadding ? 0 : '8px 24px 8px 0px' }}>
    <IconButton onClick={onClick} {...(onClick === undefined && { href })}>
      <ChevronLeftIcon />
    </IconButton>
  </div>
);

BackButton.propTypes = {
  href: PropTypes.string,
  noPadding: PropTypes.bool,
  onClick: PropTypes.func,
};
BackButton.defaultProps = {
  onClick: undefined,
  href: undefined,
  noPadding: false,
};

export default BackButton;
